import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { Router } from '@angular/router'
import { MessageService } from '@openng/optimus-ui/api'
import { catchError, throwError } from 'rxjs'
import { FuseqAuthService } from '../fuseqAuth.service'
import { SKIP_GLOBAL_ERROR_NOTIFICATIONS, MaintenanceService } from '../../_shared/maintenance/maintenance.service'

// Dedup del toast per backend irraggiungibile (status 0): evita una raffica
// di messaggi quando il server è giù e molte richieste falliscono insieme.
let lastStatusZeroToastAt = 0
const STATUS_ZERO_TOAST_COOLDOWN_MS = 30_000

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const fuseqAuthService = inject(FuseqAuthService)
  const router = inject(Router)
  const messageService = inject(MessageService)
  const maintenance = inject(MaintenanceService)

  const publicUrls = ['/nrd', '/NRDStatus', '/switch']
  const isPublicUrl = publicUrls.some(u => req.url.toLowerCase().includes(u))
  const skipNotifications = req.context.get(SKIP_GLOBAL_ERROR_NOTIFICATIONS)

  return next(req).pipe(catchError(err => {
    if (skipNotifications) {
      // richieste interne (poll maintenance): nessun toast/logout/redirect
      return throwError(() => err)
    }
    if (err) {
      console.log('Error Interceptor', err)
    }
    err.isintercepted = false
    if (err.status === 0) {
      // backend irraggiungibile (down, rete assente o timeout)
      err.isintercepted = true
      if (maintenance.phase() !== 'active') {
        const now = Date.now()
        if (now - lastStatusZeroToastAt > STATUS_ZERO_TOAST_COOLDOWN_MS) {
          lastStatusZeroToastAt = now
          messageService.add({ severity: 'error', detail: 'Server non raggiungibile. Riprova tra qualche istante.' })
        }
      }
      return throwError(() => err)
    }
    if (err.status === 401 && !isPublicUrl) {
      fuseqAuthService.logout('session', router.url)
      err.isintercepted = true
    }
    if (err.status === 403) {
      err.isintercepted = true
      return throwError(() => err.error)
    }
    if (err.status === 406) {
      console.log('errore ise auth')
      err.isintercepted = true
      messageService.add({ severity: 'error', detail: err.error.message })
    }
    if (err.status === 405) {
      console.log('delete master node')
      err.isintercepted = true
      messageService.add({ severity: 'error', detail: err.error.message })
    }
    if (err.status >= 500 && err.status < 600) {
      err.isintercepted = true
      if (err.status === 503) {
        messageService.add({ severity: 'error', detail: 'Server non disponibile. Contattare l\'amministrazione di sistema.' })
      } else if (err.status === 510) {
        messageService.add({ severity: 'error', detail: 'Server non disponibile. Contattare l\'amministrazione di sistema.' })
      } else {
        if (err.error.internal_code === 351) {
          messageService.add({ severity: 'error', detail: 'Username or Password are wrong' })
        } else if (err.error.internal_code === 451) {
          messageService.add({ severity: 'error', detail: 'Username not found' })
        } else {
          if (err.error.message) {
            messageService.add({ severity: 'error', summary: 'Error', detail: String(err.error.message).startsWith('error: ') ? err.error.message.replace('error: ', '') : err.error.message })
          } else {
            messageService.add({ severity: 'error', detail: 'Error during the comunication with the server' })
          }
        }
      }
    }
    return throwError(() => err)
  }))
}
